/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, withRouter } from 'react-router-dom';
import { IconButton, Menu, MenuItem } from '@material-ui/core';
import _ from 'lodash';
import {
  getDrugActivity,
  getCheckLogByInvoiceNum,
  setCheckLogOpen,
} from '../store/actions';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  naviagteToNDCDetailsPageAction,
  getAllNDCReferenceData,
} from '../../NDC/store/action';
import { getClaimTableInfo, navigateToClaim } from '../../Claim/store/action';
import { navigateToInvoiceAudit } from '../../../Research/InvoiceAudits/store/Actions';
import {
  getUnitConversionDetail,
  getNdcGrid,
} from '../../../Maintain/unitConversion/store/actions';
import ErrorPopup from '../../NDC/component/ErrorPopup';
import { getCalculatedData } from '../../URASearch/store/actions';
import {
  redirectURLLink,
  checkQuarterValidation,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import InvoiceChecksLog from './invoiceChecksLog';
import {
  setErrorMessageForSearch,
  dispatchActiveInvoiceNumber,
  getRosiAllocatePaymentDetail,
  getRebateProgramDropdownList,
  dispatchExistingInvoiceNumCheck,
  getExistingInvoiceNumCount,
  setSearchPickInvoiceAssScreenTab,
  dispatchFailedAPIError,
} from '../../../Tasks/AllocatePayments/store/Actions';

import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';

import { getAllocatePaymentScreenData } from '../../../Tasks/AllocatePayments/components/gridComponents/ROSIUtils';

const useStyles = makeStyles((theme) => ({
  dropDownItem: {
    padding: '10px 24px',
  },
  nestedFolder: {
    paddingRight: '16px!important',
  },
}));

function LinkButtonRender(props) {
  const classes = useStyles();
  const [showUraModal, setShowUraModal] = useState(false);
  const [showRosiModal, setShowRosiModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState();
  const [open, setOpen] = useState(false);

  const invoiceDetailsByInvoiceNum = useSelector(
    (state) =>
      state.sharedState.DisplayInvoiceReducer.invoiceDetailsByInvoiceNum
  );

  const checkLogDetails = useSelector(
    (state) => state.sharedState.DisplayInvoiceReducer.checkLogDetails
  );

  const dispatch = useDispatch();
  const history = useHistory();
  const [error, setError] = useState(null);

  const navigateToPage = (pathName, value) => {
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    if (updateTabs.findIndex((item) => item.navTo === pathName) === -1) {
      updateTabs.push({
        navTo: pathName,
        value: value,
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    }

    history.push({
      pathname: pathName,
    });
  };

  const handleViewURADetailsClick = async () => {
    setShowUraModal(false);
    const requestData = {
      drugFamilyseqNum: ['-1'],
      ndcList: ['-1'],
      mfgIdList: [invoiceDetailsByInvoiceNum?.data?.mfgId],
      rebateProgramCd: invoiceDetailsByInvoiceNum?.data?.rebateProgramCd,
      selectOneOption: 'mfg',
      planType:
        invoiceDetailsByInvoiceNum?.data?.planTypeCode === 'FD' ||
        invoiceDetailsByInvoiceNum?.data?.planTypeCode === 'ST'
          ? 'G'
          : 'C',
      qtrType: 'ALL',
    };
    const calculatedURAHeaderDataList = await dispatch(
      getCalculatedData(requestData)
    );
    if (calculatedURAHeaderDataList?.length > 0) {
      redirectURLLink(
        '/selected-ura',
        'View Calculated URA Detail',
        history,
        dispatch
      );
    } else {
      setShowUraModal(true);
    }
  };

  const handleLinkButton = async (e, type) => {
    if (type === 'Go To Limited Drug Activity') {
      await dispatch(
        getDrugActivity({
          drugSeqNum: props?.data?.drugSeqNum,
          rebateProgramCd: invoiceDetailsByInvoiceNum?.data?.rebateProgramCd,
          originalInvQtr: props?.data?.prevQtr,
          invQtr: invoiceDetailsByInvoiceNum?.data?.qtr,
        })
      );
    } else if (type === 'Go To Claims') {
      dispatch(getClaimTableInfo(true));
      dispatch(
        navigateToClaim(
          {
            rebateProgramCd: invoiceDetailsByInvoiceNum?.data?.rebateProgramCd,
            rebateProgramCdAll: null,
            paidQtr: props.invoiceOtherQtr
              ? props?.data?.prevQtr
              : invoiceDetailsByInvoiceNum?.data?.qtr,
            searchByNdc: true,
            drugSqnNum:
              props.data &&
              props.data[props.invoiceOtherQtr ? 'drugSeqNum' : 'drugseqNum']
                ? [
                    props.data[
                      props.invoiceOtherQtr ? 'drugSeqNum' : 'drugseqNum'
                    ],
                  ]
                : [],
          },
          () => {
            navigateToPage('/selected-claim', 'Selected Claim');
          },
          () => {
            setError('No claim found.');
          }
        )
      );
    } else if (type === 'Go To ROSI/PQAS') {
      dispatch(setCheckLogOpen(true));
      const response = await dispatch(
        getCheckLogByInvoiceNum(invoiceDetailsByInvoiceNum?.data?.invoiceNum)
      );
      if (response?.payload.data?.length === 1) {
        gotoRosiPqas(response?.payload.data);
      }
    } else if (type === 'Go To NDC') {
      dispatch(
        naviagteToNDCDetailsPageAction({
          succesFunc: () => {
            navigateToPage('/ndc-details', 'NDC Details');
          },
          errorFunc: () => {
            setError('Something went wrong.');
          },
          ndcDetailsTableData: [
            {
              ndc: props.data && props.data.ndc,
              drugName: props?.data?.drugName,
            },
          ],
        })
      );
      dispatch(getAllNDCReferenceData());
    } else if (type === 'Go To Invoice Audits') {
      dispatch(
        navigateToInvoiceAudit(
          {
            auditType: 'ALL',
            clearedIndex: 1,
            unclearedIndex: 1,
            asCode: 'NDC',
            rebateProgramCd: invoiceDetailsByInvoiceNum?.data?.rebateProgramCd,
            quarter: props?.data?.prevQtr,
            drugSeqNum:
              props.data && props.data.drugSeqNum
                ? [props.data.drugSeqNum]
                : [],
          },
          () => {
            navigateToPage(
              '/unitConversion-detail',
              'Display Unit Conversion for NDC'
            );
          },
          () => {
            setError('This invoice does not have audits to display.');
          }
        )
      );
    } else if (type === 'Go To Maintain Unit Conversion') {
      const arr = {
        drugSeqNum: [props.data.drugseqNum || props.data.drugSeqNum],
      };
      dispatch(getUnitConversionDetail(arr));
      const result = await dispatch(
        getNdcGrid({
          drugSeqNum: props.data.drugseqNum || props.data.drugSeqNum,
        })
      );
      if (result) {
        redirectURLLink(
          '/unitConversion-detail',
          'Display Unit Conversion for NDC',
          history
        );
      }

      // dispatch(
      //   getNdcGrid(
      //     {
      //       drugSeqNum: props.data.drugseqNum,
      //     },
      //     () => {
      //       navigateToPage(
      //         '/unitConversion-detail',
      //         'Display Unit Conversion for NDC'
      //       );
      //     },
      //     () => {
      //       setError('Something went wrong.');
      //     }
      //   )
      // );
    } else if (type === 'Go To Calculated URA') {
      handleViewURADetailsClick();
    } else {
      navigateToPage('/Wip', 'Work In Progress');
    }
  };
  // use Selector function
  const fetchSearchScreenData = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer?.pervSearchScreenData
  );
  const searchPickInvAssociateScreenObj = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer?.searchPickInvAssociateScreenObj
  );
  const errorMessagesFromRedux = useSelector(
    (state) =>
      state?.sharedState?.AllocatePaymentReducer
        ?.searchPickInvoiceAssScreenErrors
  );

  const invoiceNumberStatus = useSelector(
    (state) => state?.sharedState?.AllocatePaymentReducer?.invoiceNumCount
  );
  const activeInvoiceNumArray = useSelector(
    (state) => state?.sharedState?.AllocatePaymentReducer?.activeInvoiceNum
  );
  const UserDefaultValues = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const getQuarterDataValue = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer.quarter
  );
  const AllocatePaymentReducer = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer
  );

  // variable deceleration
  const gridRef = React.useRef();

  const [warningAlert, setWarningAlert] = React.useState(false);
  const [warningMessage, setWaringMessage] = React.useState('');
  const [modalTitle, setModalTitle] = React.useState('');
  const [values, setValues] = React.useState(
    searchPickInvAssociateScreenObj?.values
      ? searchPickInvAssociateScreenObj?.values
      : {
          selectedBy: UserDefaultValues?.defInvoiceSelectModeCd
            ? UserDefaultValues?.defInvoiceSelectModeCd
            : 'PQM',
          planTypeCd: UserDefaultValues?.planTypeCd
            ? UserDefaultValues?.planTypeCd
            : 'FD',
          rebateProgramCd: UserDefaultValues?.rebateProgramCd
            ? UserDefaultValues?.rebateProgramCd
            : '-1',
          quarterValue: null,
          invoiceNum: '',
        }
  );
  // handling onPage load call service
  React.useEffect(() => {
    dispatch(dispatchFailedAPIError(null));
  }, []);

  // set initial quarte Value
  React.useEffect(() => {
    if (Object.keys(searchPickInvAssociateScreenObj)?.length === 0) {
      if (
        getQuarterDataValue &&
        !searchPickInvAssociateScreenObj?.values?.quarterValue
      ) {
        setValues({
          ...values,
          quarterValue: autoFormateDate(getQuarterDataValue?.toUpperCase()),
        });
        dispatch(
          setSearchPickInvoiceAssScreenTab({
            ...searchPickInvAssociateScreenObj,
            values: {
              ...values,
              quarterValue: autoFormateDate(getQuarterDataValue?.toUpperCase()),
            },
          })
        );
      }
    }
  }, [getQuarterDataValue]);

  // handing highlight tab
  React.useEffect(() => {
    if (errorMessagesFromRedux?.length > 0) {
      tabHighLigther('/rebate/display-invoice', true);
    } else {
      tabHighLigther('/rebate/display-invoice', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);

  // redirect allocate payment detail screen

  const handleRedirectURLtoDetailScreen = async (row) => {
    let localErr = errorMessagesFromRedux || [];
    const invoiceNumber = invoiceDetailsByInvoiceNum?.data?.invoiceNum;
    const newObj = activeInvoiceNumArray || [];
    newObj.push({
      index: newObj.length,
      invoiceNum: invoiceNumber,
      checkLogNum: row?.checkLogNum,
      active: true,
    });
    dispatch(dispatchActiveInvoiceNumber(newObj));
    const searchScreenData = fetchSearchScreenData?.selectedRow;
    const resultData = await dispatch(
      getRosiAllocatePaymentDetail({
        invoiceNum: invoiceNumber,
        checkLogNum: row?.checkLogNum,
        checkPayeeCD: row?.checkPayeeCd,
        checkAmt: row?.checkAmt,
        mfgId: invoiceDetailsByInvoiceNum?.data?.mfgId,
        planType: invoiceDetailsByInvoiceNum?.data?.planTypeCode,
      })
    );
    const data = resultData?.headerAllocatePaymentData;
    const headerAllocatePaymentVO =
      resultData?.headerAllocatePaymentData?.headerAllocatePaymentVO;
    if (
      headerAllocatePaymentVO &&
      Object.keys(headerAllocatePaymentVO)?.length > 0
    ) {
      getAllocatePaymentScreenData(
        data,
        dispatch,
        AllocatePaymentReducer,
        history,
        newObj,
        'displayInvoice'
      );
    } else if (data?.forzenCase) {
      localErr = [];
      localErr.push({
        field: 'InvNumNotFrozen',
        errorType: 'invoiceNum',
        message: constantMessageData.INVOICE_NUMBER_NOT_FROZEN,
      });
    } else if (data?.noCheckPayeeForInvoice) {
      localErr = [];
      setWarningAlert(true);
      setModalTitle(
        `Pick an Invoice to Associate with this Check (${fetchSearchScreenData?.selectedRow?.checkLogNum})`
      );
      setWaringMessage(constantMessageData.CHECK_PAYEE_CODE_INV_NUMBER_MSG);
    } else if (
      data?.headerAllocatePaymentVO == null &&
      data?.checkPayeeMessage
    ) {
      setWarningAlert(true);
      setWaringMessage(data?.checkPayeeMessage);
      setModalTitle(
        `Pick an Invoice to Associate with this Check (${fetchSearchScreenData?.selectedRow?.checkLogNum})`
      );
    }
    dispatch(setErrorMessageForSearch([...new Set(localErr)]));
  };
  // after call exIsting invoice number available on DB or not
  React.useEffect(() => {
    let localErr = errorMessagesFromRedux || [];
    if (parseInt(invoiceNumberStatus, [0, 1]) === 1) {
      dispatch(dispatchExistingInvoiceNumCheck(''));
      localErr = localErr.filter(
        (item) =>
          item.field !== 'noInvoiceNumExist' &&
          item.field !== 'resultNotFound' &&
          item.field !== 'resultNotFound1' &&
          item.field !== 'InvNumNotFrozen'
      );
      handleRedirectURLtoDetailScreen();
    } else if (parseInt(invoiceNumberStatus, [0, 1]) === 0) {
      dispatch(dispatchExistingInvoiceNumCheck(''));
      localErr = localErr.filter(
        (item) =>
          item.errorType !== 'invoiceNum' &&
          item.field !== 'resultNotFound' &&
          item.field !== 'resultNotFound1' &&
          item.field !== 'InvNumNotFrozen'
      );
      localErr.push({
        field: 'noInvoiceNumExist',
        errorType: 'invoiceNum',
        message: `${constantMessageData.NO_INVOICE_NUMBER_EXIST} (# ${values?.invoiceNum}) .`,
      });
    }
    dispatch(setErrorMessageForSearch([...new Set(localErr)]));
  }, [invoiceNumberStatus]);
  // check validation function
  const validateRequest = () => {
    let localErr = errorMessagesFromRedux || [];
    let checkValidation = false;
    if (values.rebateProgramCd === null || values.rebateProgramCd === '-1') {
      checkValidation = true;
      localErr = localErr?.filter((item) => item.filed !== 'resultNotFound2');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: constantMessageData.REBATE_PROGRAM_REQUIRED,
      });
    }
    if (values.quarterValue === '') {
      checkValidation = true;
      localErr = localErr.filter(
        (item) => item.field !== 'quarter' && item.filed !== 'resultNotFound2'
      );
      localErr.push({
        field: 'quarter',
        errorType: 'required',
        message: constantMessageData.QUARTER_VALUE_REQUIRED,
      });
    } else if (!checkQuarterValidation(values.quarterValue)) {
      checkValidation = true;
      localErr = localErr.filter(
        (item) => item.field !== 'quarter' && item.filed !== 'resultNotFound2'
      );
      localErr.push({
        field: 'quarter',
        errorType: 'invalidFormat',
        message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
      });
    }

    dispatch(setErrorMessageForSearch([...new Set(localErr)]));
    return !checkValidation;
  };

  const [invoiceNumberDetail, setInvoiceNumberDetail] = useState({});
  const sendData = (data) => {
    setInvoiceNumberDetail(data);
  };
  React.useEffect(() => {
    if (invoiceNumberDetail) {
    }
  }, [invoiceNumberDetail]);
  useEffect(() => {
    if (checkLogDetails?.data?.length == 1) {
      if (sessionStorage.getItem('singlecheckdata') == 'true') {
        gotoRosiPqas(checkLogDetails?.data);
        sessionStorage.setItem('singlecheckdata', false);
      }
    }
  }, [checkLogDetails]);

  const gotoRosiPqas = async (dataResponse = []) => {
    const newObj = [];
    const InvNumber = invoiceDetailsByInvoiceNum?.data?.invoiceNum;
    const CheckLogNumber =
        dataResponse?.length === 1
            ? dataResponse[0]?.checkLogNum
        : invoiceNumberDetail.checkLogNum;
    newObj.push({
      index: newObj.length,
      invoiceNum: InvNumber,
      checkLogNum: CheckLogNumber,
      active: true,
    });
    const searchScreenData = fetchSearchScreenData?.selectedRow;
    const resultData = await dispatch(
      getRosiAllocatePaymentDetail({
        invoiceNum: InvNumber,
        checkLogNum: CheckLogNumber,
        checkPayeeCD: 'MD',
        checkAmt: invoiceDetailsByInvoiceNum?.totInformationalAmt || 0,
        mfgId: invoiceDetailsByInvoiceNum?.data?.mfgId,
        planType: invoiceDetailsByInvoiceNum?.data?.rebateProgramCd,
      })
    );
    const data = resultData?.headerAllocatePaymentData;
    const headerAllocatePaymentVO =
      resultData?.headerAllocatePaymentData?.headerAllocatePaymentVO;
    const headerLength =
      headerAllocatePaymentVO && Object.keys(headerAllocatePaymentVO)?.length;
    if (
      headerAllocatePaymentVO &&
      Object.keys(headerAllocatePaymentVO)?.length > 0
    ) {
      getAllocatePaymentScreenData(
        data,
        dispatch,
        AllocatePaymentReducer,
        history,
        newObj,
        'displayInvoice'
      );
    } else if (data?.forzenCase) {
      setWarningAlert(true);
      setModalTitle('Warning');
      setWaringMessage(constantMessageData.INVOICE_NUMBER_NOT_FROZEN);
    } else if (data?.noCheckPayeeForInvoice) {
      setWarningAlert(true);
      setModalTitle('Warning');
      setWaringMessage(constantMessageData.CHECK_PAYEE_CODE_INV_NUMBER_MSG);
    } else if (
      data?.headerAllocatePaymentVO == null &&
      data?.checkPayeeMessage
    ) {
      setWarningAlert(true);
      setWaringMessage(data?.checkPayeeMessage);
      setModalTitle('Warning');
    }
  };

  // const gotoRosiPqas = () => {
  //   const invoiceDataDetails =
  //     checkLogDetails?.data?.length == 1
  //       ? checkLogDetails?.data[0]
  //       : invoiceNumberDetail;
  //   handleAssociateWithCheck(invoiceDataDetails);
  //   setAlreadyExistInvoiceNum(false);
  //   const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
  //   const InvNumber = invoiceDetailsByInvoiceNum?.data?.invoiceNum;
  //   const CheckLogNumber =
  //     checkLogDetails?.data?.length == 1
  //       ? checkLogDetails?.data[0]?.checkLogNum
  //       : invoiceNumberDetail.checkLogNum;
  //   const newObj = updateDetailsAllData[`${InvNumber}-${CheckLogNumber}`];
  //   const navTo = `/allocatePaymentDetail/${CheckLogNumber}-${InvNumber}`;
  //   updateTabs.map((item) => {
  //     if (item.invoiceNum === InvNumber) {
  //       item.isAlreadyExistInvoiceNum = true;
  //       item.navTo = navTo;
  //       item.checkLogNum = CheckLogNumber;
  //       item.value = `ROSI/PQAS[${invoiceDetailsByInvoiceNum?.data?.mfgId} Inv #:${InvNumber} Chk Log #: ${CheckLogNumber}]`;
  //     }
  //     return item;
  //   });
  //   localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
  // };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <CommonModal
        className="dialog-420"
        data-testid="commonModal1"
        open={warningAlert}
        viewAction
        viewHeader
        onOk={() => setWarningAlert(false)}
        onClose={() => setWarningAlert(false)}
        okTitle="Ok"
        modalTitle={modalTitle}
        childrenComponent={<div className="p-3">{warningMessage}</div>}
      />
      <CommonModal
        data-testid="calculated-ura-common-modal"
        open={showUraModal}
        viewAction
        viewHeader
        onClose={() => setShowUraModal(false)}
        onOk={() => setShowUraModal(false)}
        okTitle="Ok"
        modalTitle="URA Detail"
        childrenComponent="No information is available for the selected request."
        className="dialog-420"
      />
      <CommonModal
        data-testid="rosipqas-common-modal"
        open={showRosiModal && checkLogDetails?.data?.length > 1}
        viewAction
        viewHeader
        onClose={() => setShowRosiModal(false)}
        onOk={() => gotoRosiPqas(checkLogDetails?.data)}
        okTitle="Ok"
        closeTitle="Cancel"
        modalTitle="Choose a Check"
        childrenComponent={
          <InvoiceChecksLog checkLogDetails={checkLogDetails} />
        }
      />
      <CommonModal
        data-testid="rosipqas-common-modal"
        open={showRosiModal && checkLogDetails?.data?.length === 0}
        viewAction
        viewHeader
        onClose={() => setShowRosiModal(false)}
        onOk={() => setShowRosiModal(false)}
        okTitle="Ok"
        modalTitle="Display Invoice"
        childrenComponent="No ROSI/PQAS data available."
        className="dialog-420"
      />
      <IconButton
        aria-label="export"
        id="lng-btn"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <SVGComponent iconName="Icon-export" />
      </IconButton>
      <Menu
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        className="export_dropdown"
      >
        <MenuItem
          role="button"
          onClick={(e) => {
            handleLinkButton(e, 'Go To Claims');
            setAnchorEl(null);
            setOpen(false);
          }}
        >
          Go to Claims
        </MenuItem>
        {props.invoiceOtherQtr && (
          <MenuItem
            role="button"
            className={classes.dropDownItem}
            style={{ padding: '6px 16px' }}
            onClick={(e) => {
              handleLinkButton(e, 'Go To Limited Drug Activity');
              setAnchorEl(null);
              setOpen(false);
            }}
          >
            Show Drug Activity
          </MenuItem>
        )}
        <MenuItem
          role="button"
          onClick={(e) => {
            handleLinkButton(e, 'Go To NDC');
            setAnchorEl(null);
            setOpen(false);
          }}
        >
          Go to NDC
        </MenuItem>
        <MenuItem
          role="button"
          onClick={(e) => {
            handleLinkButton(e, 'Go To ROSI/PQAS');
            setAnchorEl(null);
            setOpen(false);
          }}
        >
          Go to ROSI/PQAS
        </MenuItem>
        {!props.invoiceOtherQtr && (
          <MenuItem
            role="button"
            onClick={(e) => {
              handleLinkButton(e, 'Go To Calculated URA');
              setAnchorEl(null);
              setOpen(false);
            }}
          >
            Go to Calculated URA
          </MenuItem>
        )}
        <MenuItem
          role="button"
          onClick={(e) => {
            handleLinkButton(e, 'Go To Maintain Unit Conversion');
            setAnchorEl(null);
            setOpen(false);
          }}
        >
          Go to Maintain Unit Conversion
        </MenuItem>
      </Menu>
      <ErrorPopup
        modalTitle="Display Invoice"
        errorPopupMessage={error}
        onClose={() => setError(null)}
      />
    </>
  );
}

export default withRouter(LinkButtonRender);
